import * as locationTypes from '../../../../common/redux/actions/types/LocationTypes';

export default function filterEdiMailboxesIfExistsInPostalOperators(
  ediMailboxes,
  postalOperators,
  reportDefinition,
) {
  const result = [];

  if (!reportDefinition || !postalOperators || postalOperators.length === 0) {
    return [...ediMailboxes];
  }

  const addIfExists = (mailboxCode) => {
    if (ediMailboxes.includes(mailboxCode)) {
      result.push(mailboxCode);
    }
  };

  // eslint-disable-next-line no-plusplus
  for (let index = 0; index < postalOperators.length; index++) {
    const postalOperator = postalOperators[index];

    addIfExists(postalOperator.value);
    // eslint-disable-next-line
    for (let i = 0; i < postalOperator.children.length; i++) {
      const mailbox = postalOperator.children[i];
      if (reportDefinition.locationType === locationTypes.OPERATOR) {
        if (ediMailboxes.includes(mailbox.value)) {
          result.push(...postalOperator.children.map(child => child.value));
          break;
        }
      } else {
        addIfExists(mailbox.value);
      }
    }
  }

  return result;
}
